import { PUBLIC_CHAIN } from '$env/static/public';
import dayjs from 'dayjs';

const todayStr = dayjs().format('MMM D YYYY hh:mm A');

export const PASSKEY_NAME =
  (PUBLIC_CHAIN === 'GNOSIS' ? 'Metri Passkey ' : 'Metri Passkey [TESTNET] ') + todayStr;
